import ActionTypes, { TTicketState } from './types';
import { Actions, TDefRequest } from '../Action';

const GetTicketAction = new Actions('GET_TICKET', ActionTypes);

export interface TypeGetTicketR extends TDefRequest {
  event_id: number;
}
export const GetTicket = {
  request: (payload: TypeGetTicketR) => GetTicketAction.request(payload),
  success: (payload: TTicketState['data']) => GetTicketAction.success(payload || {}),
  error: (message: string) => GetTicketAction.error(message),
};
